export const SEARCH_CERTIFICATE = {
  longSentence: 'searchResult:Component-Certificado:variant-fraseLonga',
  shortSentence: 'searchResult:Component-Certificado:variant-fraseCurta',
};

export const SEARCH_RESULT_COMPONENT = 'searchResult:Component-';
